import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";

export default {
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
      focus: true,
    };
  },
  created() {
    EventBus.$on(`${this.id}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }

      this.focusInput();
    });

    EventBus.$on(`${this.id}-add`, (data) => {
      if (data.id) {
        this.createCollection();
      }
    });
  },

  methods: {
    createCollection() {
      const formData = new FormData(this.$refs.form.$refs.form);

      formData.append("folders", JSON.stringify([]));
      formData.append("files", JSON.stringify([]));

      this.$axios
        .post(`${baseUrl}/collectionadd`, formData)
        .then((r) => {
          //update name
          EventBus.$emit("mobile-collections-update", {});

          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });

          //reset the focus
          this.focus = false;
        })
        .catch((e) => {
          errorDispatch(i18next.t("error.add_collection"));
        });
    },

    enterFunc(e) {
      e.preventDefault();

      this.createCollection();
    },
    focusInput() {
      this.focus = !this.focus;
    },
  },
};
